import { createPermission } from '@backstage/plugin-permission-common';

export const recommendedDocsManagePermission = createPermission({
  name: 'hone.techdocs.recommended.manage',
  attributes: {},
});
